import {
  ActionType,
  IDashboardInfoResponse,
} from "models/dashboard/dashboardInfo";

export const getDashboardInfoAction = (payload?: any) => {
  return {
    type: ActionType.DASHBOARD_INFO,
    payload,
  };
};

export const handleErrorAction = (payload: string) => {
  return {
    type: ActionType.DASHBOARD_INFO_ERROR,
    payload,
  };
};

export const handleSuccessAction = (payload: IDashboardInfoResponse) => {
  return {
    type: ActionType.DASHBOARD_INFO_SUCCESS,
    payload,
  };
};

export const handleResetAction = () => {
  return {
    type: ActionType.DASHBOARD_INFO_RESET,
  };
};
